import { CHECKLIST_ITEM_PARTNER_CATEGORY } from "../../../constants/automapPartnershipConstants";
import { useLocale } from "../../../intl";
import { getBuyerChecklistImportanceLabel } from "../../../intl/buyerChecklistCopy";
import { ChecklistPartnerCta } from "../partnerships/VehiclePartnerServices";

export default function BuyerChecklistItem({
  item,
  checked = false,
  onToggle,
  compact = false,
  showImportance = false,
  listingId = null,
  dealerId = null,
  defaultVehicleContext = null,
  highlighted = false,
}) {
  const { t, exists } = useLocale();
  if (!item) return null;
  const inputId = `checklist-item-${item.id}`;
  const partnerCategory = CHECKLIST_ITEM_PARTNER_CATEGORY[item.id];

  return (
    <li
      className={`buyer-checklist-item ${compact ? "buyer-checklist-item--compact" : ""}${
        highlighted ? " buyer-checklist-item--highlighted" : ""
      }`.trim()}
    >
      <label className="buyer-checklist-item__label" htmlFor={inputId}>
        <input
          id={inputId}
          type="checkbox"
          className="buyer-checklist-item__checkbox"
          checked={Boolean(checked)}
          onChange={(event) => onToggle?.(item.id, event.target.checked)}
        />
        <span className="buyer-checklist-item__content">
          <span className="buyer-checklist-item__title">{item.title}</span>
          {!compact && item.description ? (
            <span className="buyer-checklist-item__description">{item.description}</span>
          ) : null}
          {showImportance && item.importance ? (
            <span className={`buyer-checklist-item__importance buyer-checklist-item__importance--${item.importance}`}>
              {getBuyerChecklistImportanceLabel(t, exists, item.importance)}
            </span>
          ) : null}
          {partnerCategory ? (
            <ChecklistPartnerCta
              itemId={item.id}
              category={partnerCategory}
              listingId={listingId}
              dealerId={dealerId}
              defaultVehicleContext={defaultVehicleContext}
            />
          ) : null}
        </span>
      </label>
    </li>
  );
}
